module.exports = __webpack_public_path__ + "img/4-3-1-5-3-preview-gz-Seminar-e.cbbdb698.jpg";